import { render, staticRenderFns } from "./PageMagento.vue?vue&type=template&id=9388136c&"
import script from "./PageMagento.vue?vue&type=script&lang=ts&"
export * from "./PageMagento.vue?vue&type=script&lang=ts&"
import style0 from "./PageMagento.vue?vue&type=style&index=0&id=9388136c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports